// **React Imports
import { useMemo } from 'react'

// **Utils Imports
import { DEMO_TENANTS_HOSTNAMES, ROLES } from '../utils/constant'
import { getUserRole } from '../utils/utils'

const useDemoUser = () => {
  // variables
  const role = useMemo(() => getUserRole(), [])

  const isDemoUser = useMemo(() => role?.toLowerCase() === ROLES.DEMO, [role])

  const isDemoTenant = useMemo(() => {
    const hostName = window.location.hostname
    return DEMO_TENANTS_HOSTNAMES.includes(hostName)
  }, [])

  return {
    isDemoUser,
    isDemoTenant
  }
}

export default useDemoUser
